/* eslint-disable */
import styled from '@emotion/styled'
import { spacing } from '../../foundation/spacing'
import { fontSize } from '../../foundation/fontSize'
import { borderRadius } from '../../foundation/borderRadius'
import { colors } from '../../foundation/colors'


export const TextArea = styled.textarea({
  width: '100%',
  fontFamily: 'inherit',
  padding: spacing.X12,
  fontSize: fontSize.X12,
  color: colors.GRAYSCALE.X70,
  backgroundColor: colors.GRAYSCALE.X0,
  borderRadius: borderRadius.X8,
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: colors.GRAYSCALE.X30,
  '&:focus': {
    borderColor: colors.GRAYSCALE.X70,
  },

  '&:disabled': {
    background: colors.GRAYSCALE.X10,
  },
  resize: 'none',
})
